import { useState } from 'react'
import ContenutiCorsoService from '../services/ContenutiCorsoService/ContenutiCorsoService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useCorsi = () => {
    const [loadingState, setLoadingState] = useState({
      isLoadingContenutoCreating: false,
      isLoadingContenutoUpdate: false,
      isLoadingContenutoDelete: false,
      isLoadingContenutoClone: false,
      isLoadingFindContenutiByParams: false,
    });

    const [modalState, setModalState] = useState({
      showModalDeleteContenuto: false,
    });


    const createContenuto = async (data) => {
      setLoadingState({ ...loadingState, isLoadingContenutoCreating: true });
      try {
        let response = await ContenutiCorsoService.createContenuto(data);
        if(response?.id) {
          alertService.success("Contenuto creato con successo", {autoClose: true});
          return response;
        }
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingContenutoCreating: false });
      }
  }

    const findContenutiByParams = async (data) => {
      setLoadingState({ ...loadingState, isLoadingFindContenutiByParams: true });
      try {
        let obj;
        let response = await ContenutiCorsoService.findContenuti(data);
        const res = await response.json();
        const totalRecord = response.headers.get('X-Total-Record');
          obj = {
            data: res,
            count: totalRecord
          }
        return obj
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingFindContenutiByParams: false });
      }
  }


  
    const updateContenuto = async (data, selectedFile) => {
      setLoadingState({ ...loadingState, isLoadingContenutoUpdate: true });
      try {
        let response = await ContenutiCorsoService.updateContenuto(data);
        if(!selectedFile) {
          alertService.success("Contenuto aggiornato con successo", {autoClose: true});
        }
        return response
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingContenutoUpdate: false });
      }
  }

    const cloneContenuto = async (data) => {
      setLoadingState({ ...loadingState, isLoadingContenutoCreating: true });
      try {
        let response = await ContenutiCorsoService.cloneContenuti(data);
        alertService.success("Contenuto duplicato con successo", {autoClose: true});
        return response
      } catch (error) {
        handleError(error)
      } finally {
        setLoadingState({ ...loadingState, isLoadingContenutoCreating: false });
      }
  }

  const deleteContenuto = async (data) => {
    setLoadingState({ ...loadingState, isLoadingContenutoDelete: true });
    try {
      let res = await ContenutiCorsoService.deleteContenuto(data);
      const response = await res.json();
      alertService.success("Contenuto eliminato con successo", {autoClose: true});
      setModalState(state => ({ 
        ...state,
        showModalDeleteContenuto: false, 
        }));
      return response
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingContenutoDelete: false });
    }
}

  return {
    loadingStateContenutiCorso: loadingState,
    createContenuto,
    deleteContenuto,
    findContenutiByParams,
    modalStateContenuto: modalState,
    setModalStateContenuto: setModalState,
    updateContenuto,
    cloneContenuto
  };      
}

export default useCorsi;